export default {
    // banner
    'career.banner.title': `Make fun make sense`,
    'career.banner.description': '欢迎加入我们！',
    'career.banner.buttonText': `浏览职位`,
    // content 1
    'career.content1.title': '关于我们',
    'career.content1.description': `我们相信：简单、坦诚、自驱、上进、分享、追求极致的氛围可以激发团队的活力与创造力`,
    // content 2
    'career.content2.1.title': 'Maria',
    'career.content2.1.subtitle': `Unity3D工程师`,
    'career.content2.1.description': `“在HABBY,能够和很多志同道合的小伙伴一起创造精品的游戏,让很多可能变成了现实！”`,
    'career.content2.2.title': 'Joel',
    'career.content2.2.subtitle': `产品运营`,
    'career.content2.2.description': `“我感受到HABBY与我曾经工作过的其他公司最大的不同之一就是,公司能够提供真正平等、自由、有爱、团结的工作氛围,并鼓励每个人发现自己更好的一面,成长为更好的自己！”`,
    // content 3
    'career.content3.title': '我们在哪',
    'career.content3.description': `Habby是一家全球化的精品游戏发行公司,目前在新加坡、北京、上海均设有分公司,未来还会不断开拓。`,
    'career.content3.location.1.title': '北京,中国',
    'career.content3.location.1.desc': '10 职位',
    'career.content3.location.2.title': '新加坡,新加坡',
    'career.content3.location.2.desc': '6 职位',
    // content 4
    'career.content4.modal.applyButtonText': '申请职位',
    'career.content4.title': '职位列表',
    'career.content4.description': `如果你想加入海彼,请将您的简历+申请职位发给我：简历接收邮箱：`,
    'career.content4.description.email': 'zhangxinzhe@habby.com',
    'career.content4.jobs.buttonText': '详情',
    'career.content4.jobs': [
        // 2026.3.23 新增
        {
            title: '游戏研发设计师（策划&技术）',
            location: '北京',
            type: '策划&技术',
            full: '实习',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.参与 Demo 的完整开发：玩法创意 → 原型实现 → 持续迭代；\n2.在导师指导下，将创意拆解为系统逻辑，并用Unity/C#实现核心玩法；\n3.负责功能模块的编码、调试与性能优化；\n4.与美术、程序紧密协作，推动创意落地，输出可玩版本。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.2026/2027届全日制在校生，可全职实习3个月及以上；\n2.独立或合作完成过可运行的游戏Demo（休闲手游 / 单机 / 独立游戏均可）；\n3.热爱游戏，对开发充满激情，是深度玩家，对游戏和游戏开发有一定思考；\n4.熟练使用Unity与C#、若能熟悉 Unreal、Cocos、C++、Lua 等任一技术更佳；\n5.逻辑清晰，具备良好的分析与问题解决能力，积极开朗，执行力强，善于沟通协作；\n6.投递时请附上作品集或演示视频链接（例如Google Drive、Bilibili、YouTube等）。'
                },
                {
                    title: '你将收获',
                    content:
                        '1.独立参与完整的游戏开发流程，从创意到成品可玩版本；\n2.免费三餐+无限零食饮料+志同道合的伙伴，以及丰富多彩的体育活动与团建；\n3.置身于开放、有趣、鼓励创意的团队氛围中，享受全球顶尖的游戏创作环境。'
                }
            ]
        },
        {
            title: '游戏3D动画设计师',
            location: '北京',
            type: '美术',
            full: '实习',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.参与手游欧美卡通风格项目的3D动作设计；\n2.根据角色性格进行基础动画制作与设计；\n3.协助制定动作制作规范；\n4.与策划、程序、模型等岗位协作，确保动画符合整体设计需求。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.动画、美术、数字媒体技术等相关专业，2026届在校生优先，实习期间表现优异可转正；\n2.具备扎实的动作设计基础，对动画节奏有基本理解；\n3.熟悉3ds Max、Maya等主流3D动画制作软件（了解Blender者更佳）；\n4.了解Unity动画系统者优先；\n5.热爱游戏行业，有良好的团队协作和沟通能力。'
                }
            ]
        },
        {
            title: '游戏音效设计师',
            location: '北京',
            type: '音效',
            full: '实习',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责游戏产品中原创配乐与音效全流程工作；\n2.根据项目需求，进行音频资源的管理、维护；\n3.配合程序与策划，沟通及解决音频相关问题；\n4.在完成需求的基础上逐步完善制作规范，提升用户体验。'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.音乐制作或录音相关类专业，熟练掌握一款主流编曲软件，擅长多种风格（包括但不限于管弦、电子等）；\n2.热爱游戏，对声音敏感，具备音频设计、制作能力；\n3.能在工作中学习成长，持续优化制作质量与效率；\n4.有即兴创作能力者优先。'
                }
            ]
        },
        {
            title: '游戏原画设计师',
            location: '北京',
            type: '美术',
            full: '实习',
            descriptions: [
                {
                    title: '岗位介绍',
                    content:
                        '我们正在寻找充满激情、有创造力且对游戏美术充满热爱的伙伴加入我们的团队。你将与团队一起，共同为玩家打造引人入胜的视觉体验，同时直接参与到游戏的具体制作，在职业生涯初期探索并找到最适合自己的方向。'
                },
                {
                    title: '岗位职责',
                    content:
                        '1.协助绘制或设计游戏demo的美术风格以及所有相关美术资源（设计角色、场景、道具，UI等各种美术资源）；\n2.协助制作游戏内特效、动画或材质贴图；\n3.在资深美术师的指导下，学习并掌握游戏美术制作流程和工具；\n4.参与美术讨论，贡献创意，并接收反馈进行迭代优化；\n5.确保所有美术资源符合游戏整体的美术风格和技术标准。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.美术、设计专业或自学成才，拥有扎实的美术基础和好的审美；\n2.对游戏行业有浓厚的兴趣和热情，理解游戏美术在玩家体验中的重要性；\n3.具备良好的学习能力和沟通能力，能积极主动地与团队成员合作；\n4.熟悉并掌握主流的绘画设计软件，如：Photoshop、Illustrator、Procreate。\n\n请在投递简历时附上你的个人作品集，作品集是展示潜力的重要依据。'
                },
                {
                    title: '加分项',
                    content:
                        '- 熟练掌握 3D 建模软件（如 Maya, Blender, ZBrush, 3ds Max）或游戏引擎（如 Unity, Unreal Engine）。\n- 有个人游戏项目或参与过游戏Jam（游戏开发比赛）的经验。\n- 对欧美美术风格有深入研究。'
                }
            ]
        },
        {
            title: '游戏特效设计师',
            location: '北京',
            type: '美术',
            full: '实习',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责 Unity 项目内游戏 / 交互特效制作，包括技能、UI、场景氛围等特效落地与优化；\n2.配合策划、程序、美术需求，完成特效设计、制作、调试、迭代；\n3.使用 Unity 粒子系统、动画、材质等实现需求。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.1年以内 Unity 特效相关经验 / 实习经验，能独立完成常规游戏特效；\n2.熟练使用Unity 粒子系统，了解材质、贴图等；\n3.会使用主流特效 / 美术工具：AE、PS 等，了解ASE/ShaderGraph加分；\n4.工作踏实、沟通顺畅，能按时交付，愿意持续学习；\n5.对休闲手游特效有兴趣，愿意做好看又好跑的效果。'
                }
            ]
        },
        {
            title: '游戏2D动效设计师',
            location: '北京',
            type: '美术',
            full: '实习',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.制作游戏UI动效，界面切换演示、过场、交互反馈等动画；\n2.制作游戏内的角色动画，道具动画；\n3.制作游戏内2D特效动画；\n4.参与需求前期设计，给出动画制作方案。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.了解视觉引导等交互相关设计语言；\n2.有坚实的动画节奏表现能力，动画设计有新意；\n3.有UE/UX动效设计的经验；\n4.熟练使用Particle system、spine、Unity2DAnimation；\n5.可以使用AE、XD等软件制作交互演示流程；\n6.爱玩游戏，对游戏行业充满热情，了解时下热门产品，具备一定产品思维，具有良好的团队合作意识和沟通技巧。'
                }
            ]
        },
        // //2026.3.23
        {
            title: '游戏客户端开发工程师',
            location: '北京',
            type: '视频设计',
            descriptions: [
                {
                    title: '职位要求',
                    content:
                        '1. 4年以上unity前端逻辑开发经验。\n2.熟练掌握UGUI的使用，对UGUI有深入的理解。\n3.熟练使用Unity进行扩展工具的开发。\n4.熟练掌握lua脚本。'
                },
                {
                    title: '综合素质',
                    content:
                        '1.（重要）有丰富的业务逻辑设计和开发经验，善于优化和重构业务相关逻辑结构。\n2. 逻辑思维能力强，学习能力强，品质导向。\n3. 具有良好的沟通能力，善于表达自己的观点。\n4. 能够快速进行框架搭建和原型设计。'
                }
            ]
        },
        {
            title: '游戏运营宣传设计师',
            location: '北京',
            type: '运营',
            descriptions: [
                {
                    title: '岗位要求',
                    content:
                        '1.总体要求：热情+自驱 + 高审美 + 有趣\n2.审美好，创意能力强，做出能打动玩家的设计\n3.具备出色的平面设计能力和一定的插画水准（辅助创意），具备用不多的游戏资源设计出高品质运营宣传图的能力\n4.擅长欧美卡通方向\n5.强目标感，有明确追求的方向，对自己所做有高品质要求\n6.自发推进，可以在一个开放自由的工作环境工作推进出好的结果\n7.开放意识和心态，接受新的方法，工具和优化现有的工作模式\n8.思维表达清晰，沟通简单高效且逻辑清楚\n9.了解并熟悉常用AI绘图工具，如SD、MJ等\n10.对游戏有着浓厚的热情，对Habby游戏有热情为佳'
                },
                {
                    title: '岗位职责',
                    content:
                        '1.和运营团队紧密配合，讨论和推进创意，负责上线游戏的运营活动的物料设计\n2. 使用现有项目的美术资源，结合自身美术能力，表达创意，创作出不同场景需求使用的插图或者平面设计\n3. 根据结果总结积累经验，优化设计和效率\n4. 与外包团队沟通协作，能独立把控外包设计质量和进度\n5.快速学习了解新的工具和方法，提升效率和质量，应用到实际项目'
                }
            ]
        },
        {
            title: '游戏高级UI设计师',
            location: '北京',
            type: '美术',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责游戏内UI界面的整体视觉设计包装；\n2.制定项目的UI风格；'
                },
                {
                    title: '任职要求',
                    content:
                        '1.有较好的平面设计基础，对市场流行的设计审美有成熟判断；\n2.优秀的团队协作能力，能顺滑的衔接与策划，交互，动效，还原，程序合作流程；\n3.优秀的绘制基础，优秀的图形设计，色彩构成，精修刻画能力；对游戏交互有较深理解；\n4.有较强的设计归纳总结能力，在工作中能有一定方法论沉淀，推动团队设计力进步；\n5.优秀的设计把控能力，对基础设计规范和资源输出管理有丰富经验；'
                }
            ]
        },
        {
            title: '游戏原画师(角色+场景)',
            location: '北京',
            type: '游戏原画',
            descriptions: [
                {
                    title: '关键词',
                    content:
                        '欧美卡通、角色+场景、审美好、沟通好、思维跳跃、潮、对国外流行比较了解'
                },
                {
                    title: '总体要求',
                    content:
                        '1. 擅长欧美卡通方向，匹配欧美卡通项目风格\n2.强目标感，有明确追求的方向，对自己所做有品质的要求\n3.独立自主与项目成员沟通拆解需求，确定解决方案并且按时落地结果\n4.自发推进，在一个开放自由的工作环境工作并且对结果负责\n5.有任务管理和时间计划，可以并行安排好多不同优先级的任务需求\n6.开放意识和心态，接受新的方法和优化现有的工作模式\n7.思维表达清晰，沟通逻辑清楚\n8.有大公司和成功项目的经验优先，对游戏有着浓厚的热情，有自己对于游戏的理解，对Habby游戏有热情为佳'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.3年以上游戏开发经验，和项目团队紧密配合，独立自主沟通拆解需求确定方案，在时间计划内完成角色和场景的原画设计，推进项目的设计进度\n2.和其他美术职能紧密配合，调试以寻求最佳呈现结果\n3.沟通简单顺畅，可以高效清晰讨论问题，开放思维，能接受不同意见\n4.有关于美术设计的方法论和经验，可以创造有趣且吸引人的角色，场景等游戏内的元素'
                }
            ]
        },
        {
            title: '游戏动画师',
            location: '北京',
            type: '研发',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.制作游戏UI动效，界面切换演示、过场、交互反馈等动画；\n2.参与需求的前期设计，配合UI提出交互方案；'
                },
                {
                    title: '任职要求',
                    content:
                        '1.动画专业本科以上学历，了解视觉引导等交互相关设计语言；\n2.有坚实的动画节奏表现能力，动画设计有新意；\n3.熟练使用Particle system 、 Unity2DAnimation ；\n4.可以使用AE、XD等软件制作交互演示流程；\n5.热爱游戏，审美好，对工作热情主动，认自负责，具有良好的团队合作意识和沟通技巧。'
                }
            ]
        },
        // BASE 新加坡
        {
            title: 'Senior 2D Animator',
            location: 'Singapore',
            type: 'Operator',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.为游戏资产、过场动画等制作视觉效果出色的UI、2D动画和特效；\n2.与游戏开发团队合作，确保所有资产符合技术要求和性能标准；\n3.构思并开发最适合休闲移动游戏的原创动画创意；\n4.保持所有游戏元素的一致性和高质量的美学标准。\n5.通过利用最佳实践和工具，识别和优化动画制作流程。\n6.关注行业趋势、技术和动画领域的新兴技术。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.5年以上西方休闲或中核游戏移动游戏开发经验；熟悉西方风格的游戏美术。\n2.拥有完整的Unity移动游戏开发经验；\n3.能够独立制作UI、2D动画和特效等；\n4.接受团队反馈时谦虚且尊重；\n5.对游戏充满热情！'
                }
            ]
        },
        //2024.12.4 新加坡新增
        {
            title: 'Marketing Video Content Designer (KR)',
            location: 'Seoul',
            type: 'Marketing Video Content Designer (KR)',
            full: 'Full Time(Hybrid)',
            descriptions: [
                {
                    title: '직무 설명:',
                    content:
                        '- 한국 시장을 대상으로 창의적인 UA 및 브랜딩 영상, 마케팅 캠페인, 소셜 미디어, 프로모션용 광고 영상 콘텐츠 제작 \n- 모바일 게임 산업의 최신 트렌드를 반영하여 영상 제작\n- 영상 성과와 마케팅 팀의 피드백을 바탕으로 전략 분석 및 제작'
                },
                {
                    title: '자격 요건:',
                    content:
                        '- 게임 또는 엔터테인먼트 업계에서 2년 이상의 영상 콘텐츠 제작 및 편집 경력이 있으신 분\n- Adobe Premiere Pro (PR), AR, After Effects 등의 영상 편집 소프트웨어에 능숙하신 분\n- 빠르게 변화하는 환경에서 협업하며 기한을 맞출 수 있는 뛰어난 소통 능력이 있으신 분\n- 게임 산업 트렌드에 대한 깊은 이해가 있으신 분\n- 시각적 미적 감각과 스토리텔링 능력이 뛰어나며 세부 사항에 대한 높은 주의력이 있으신 분'
                },
                {
                    title: '우대 사항:',
                    content:
                        '- 영어 또는 중국어 가능자\n- 마케팅에 대한 깊은 이해가 있으신 분\n- 3D 프로그램 사용 경험이 있으신 분'
                }
            ]
        },
        {
            title: 'Marketing Video Content Designer (JP)',
            location: 'Tokyo',
            type: 'Marketing Video Content Designer (JP)',
            full: 'Full Time(Hybrid)',
            descriptions: [
                {
                    title: '職務内容：',
                    content:
                        '- 日本市場をターゲットにした、革新的なユーザー獲得（UA）、ブランド動画広告、およびマーケティングキャンペーン、SNS、プロモーション用の動画コンテンツを制作する。\n- モバイルゲーム業界の最新トレンドを把握し、これらの洞察を動画戦略に取り入れる。\n- 動画のパフォーマンスやマーケティングチームからのフィードバックに基づいて戦略を調整する。'
                },
                {
                    title: '応募条件：',
                    content:
                        '- 動画コンテンツ制作および編集における2年以上の実務経験（ゲームまたはエンターテインメント業界での経験が望ましい）。\n- Adobe Premiere Pro (PR)、After Effects、ARなどの動画編集ソフトウェアに精通していること。\n- 優れたコミュニケーション能力を持ち、迅速なペースでのコラボレーションや締め切り遵守が可能であること。\n- ゲーム業界のトレンドに対する深い理解を持つこと。\n- 優れたストーリーテリング能力、強い視覚的センス、および細部への注意力を有すること。'
                },
                {
                    title: '優遇条件：',
                    content:
                        '- 英語または中国語能力\n- カジュアルゲームマーケティングに対する深い理解\n- 3Dプロジェクトの経験'
                }
            ]
        },
    ]
};
